const STORAGE_KEY = 'bm.recentName';

/**
 * Der zuletzt benutzte Spielername.
 *
 * Ausschließlich als Vorbelegung für die Suche nach dem eigenen Platz gedacht:
 * Wer seinen Tab verliert, sucht sich nach dem Neustart über den Namen wieder —
 * und soll ihn dafür nicht aus dem Gedächtnis kramen müssen. Bewusst im
 * `localStorage` und nicht neben dem Session-Token: Der Name ist kein Geheimnis
 * und soll gerade den Fall überleben, in dem das Token weg ist.
 */
export function rememberName(name: string): void {
  try {
    localStorage.setItem(STORAGE_KEY, name);
  } catch {
    // Ein gesperrter Speicher kostet nur den Komfort, nicht die Funktion.
  }
}

export function recallName(): string {
  try {
    return localStorage.getItem(STORAGE_KEY) ?? '';
  } catch {
    return '';
  }
}
